import { defineAsyncComponent } from 'vue';
import type { ModularBlockConfig } from '../../../frontend/types';
import { blockCTASectionFields } from './groq';

/** Shared registry entry. Lazy: not on the critical rendering path. */
export const ctaSectionBlockConfig = {
  name: 'outer-block-cta',
  component: defineAsyncComponent(() => import('./CmsCTASection.vue')),
  innerComponent: defineAsyncComponent(() => import('./CTASection.vue')),
  fields: blockCTASectionFields,
} satisfies ModularBlockConfig;
